import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import './registerServiceWorker'
import 'bulma/css/bulma.css'
import 'bulma-extensions/dist/css/bulma-extensions.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheckCircle)
library.add(faBan)

Vue.component('fas', FontAwesomeIcon)


Vue.config.productionTip = true

const token = localStorage.getItem('token');



if (token) {
    store.commit("LOGIN")
    axios.defaults.headers.common['Authorization'] = token
} else {

    router.push({ path: '/login' });
}





new Vue({
    router,
    store,

    render: h => h(App)
}).$mount('#app')